var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2 range-report", attrs: { fluid: "" } },
    [
      _c("RangePicker", {
        attrs: { range: this.getDefaultWeek() },
        on: { reloadData: _vm.loadData }
      }),
      _vm._v(" "),
      _vm.checkGate("sales-access")
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                [
                  _c("v-subheader", [_vm._v("Sales")]),
                  _vm._v(" "),
                  _c(
                    "v-data-table",
                    {
                      staticClass: "elevation-1",
                      attrs: {
                        headers: _vm.salesHeaders,
                        items: _vm.salesreport,
                        "items-per-page": 50,
                        "show-expand": "",
                        expanded: _vm.expanded
                      },
                      on: {
                        "update:expanded": function($event) {
                          _vm.expanded = $event
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "expanded-item",
                            fn: function(ref) {
                              var salesHeaders = ref.salesHeaders
                              var item = ref.item
                              return [
                                item.Notes != null ||
                                item.ccNotes != null ||
                                item.cashNotes != null
                                  ? _c("td", { attrs: { colspan: 12 } }, [
                                      _c("ul", { staticClass: "notes" }, [
                                        _c("li", [
                                          _c("sub", [_vm._v("Notes")]),
                                          _vm._v(" "),
                                          _c("p", [_vm._v(_vm._s(item.Notes))])
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("sub", [
                                            _vm._v("Reason for CC Discrepancy")
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(_vm._s(item.ccNotes))
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("li", [
                                          _c("sub", [
                                            _vm._v(
                                              "Reason for Cash Discrepancy"
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(_vm._s(item.cashNotes))
                                          ])
                                        ])
                                      ])
                                    ])
                                  : _vm._e()
                              ]
                            }
                          },
                          {
                            key: "item.T_Date",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      new Date(item.T_Date).toLocaleString(
                                        "en-AU",
                                        {
                                          timeZone: "UTC",
                                          weekday: "short",
                                          year: "numeric",
                                          month: "short",
                                          day: "numeric"
                                        }
                                      )
                                    ) +
                                    "\n        "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2003699127
                      )
                    },
                    [
                      _vm._v(" "),
                      _vm._v(" "),
                      _c("template", { slot: "body.append" }, [
                        _c("tr", { staticClass: "pink--text" }, [
                          _c("th", { staticClass: "text-start" }, [
                            _vm._v(" ")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v("Totals")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(
                              "$" +
                                _vm._s(_vm.sum(_vm.salesreport, "totalSales"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(
                              "$" + _vm._s(_vm.sum(_vm.salesreport, "PP_Sales"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(
                              "$" +
                                _vm._s(_vm.sum(_vm.salesreport, "calcCCSales"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(
                              "$" +
                                _vm._s(_vm.sum(_vm.salesreport, "ccTerminal"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  _vm.sum(_vm.salesreport, "ccDiscrepancy")
                                )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  _vm.sum(_vm.salesreport, "calcCashSales")
                                )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(
                              "$" +
                                _vm._s(_vm.sum(_vm.salesreport, "cashTotal"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(
                              "$" +
                                _vm._s(_vm.sum(_vm.salesreport, "cashOnHand"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(
                              "$" +
                                _vm._s(
                                  _vm.sum(_vm.salesreport, "cashDiscrepancy")
                                )
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(
                              "$" +
                                _vm._s(_vm.sum(_vm.salesreport, "deposited"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(
                              "$" + _vm._s(_vm.sum(_vm.salesreport, "banked"))
                            )
                          ])
                        ])
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _vm.user.roles.includes("instructor") ||
          _vm.user.roles.includes("admin")
            ? _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("v-subheader", [_vm._v("Jumps")]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      disabled: this.user.roles.includes("instructor"),
                      items: _vm.instructors,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Select Instructor"
                    },
                    model: {
                      value: _vm.currentInstructor,
                      callback: function($$v) {
                        _vm.currentInstructor = $$v
                      },
                      expression: "currentInstructor"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-data-table",
                    {
                      attrs: {
                        "no-data-text":
                          "Select an Instructor from the list above",
                        headers: _vm.headers,
                        items: _vm.detailbyID,
                        "item-key": "id"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          new Date(
                                            item.startTime
                                          ).toLocaleString("en-AU", {
                                            timeZone: "UTC",
                                            weekday: "short",
                                            year: "numeric",
                                            month: "short",
                                            day: "numeric"
                                          })
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.name))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.jumps))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.wc))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.wc2))])
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2970944068
                      )
                    },
                    [
                      _vm._v(" "),
                      _c("template", { slot: "body.append" }, [
                        _c("tr", { staticClass: "pink--text" }, [
                          _c("th", { staticClass: "title" }, [
                            _vm._v("Totals")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.sum(_vm.detailbyID, "jumps")))
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.sum(_vm.detailbyID, "wc")))
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.sum(_vm.detailbyID, "wc2")))
                          ])
                        ])
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.checkGate("aircrafts-log-mgmt")
            ? _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("v-subheader", [_vm._v("Loads")]),
                  _vm._v(" "),
                  _c("v-select", {
                    attrs: {
                      disabled: this.user.roles.includes("pilot"),
                      items: _vm.pilots,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Select Pilot"
                    },
                    model: {
                      value: _vm.currentPilot,
                      callback: function($$v) {
                        _vm.currentPilot = $$v
                      },
                      expression: "currentPilot"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-data-table",
                    {
                      attrs: {
                        headers: _vm.loadsHeaders,
                        "no-data-text": "Select a Pilot from the list above",
                        items: _vm.loadsByPilot,
                        "item-key": "id"
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c("tr", [
                                  _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          new Date(
                                            item.loadDate
                                          ).toLocaleString("en-AU", {
                                            timeZone: "UTC",
                                            weekday: "short",
                                            year: "numeric",
                                            month: "short",
                                            day: "numeric"
                                          })
                                        ) +
                                        "\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.name))]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(item.completed))])
                                ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        823196717
                      )
                    },
                    [
                      _vm._v(" "),
                      _c("template", { slot: "body.append" }, [
                        _c("tr", { staticClass: "pink--text" }, [
                          _c("th", { staticClass: "title" }, [
                            _vm._v("Totals")
                          ]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("th", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(_vm.sum(_vm.loadsByPilot, "completed"))
                            )
                          ])
                        ])
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.checkGate("aircrafts-log-mgmt")
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-subheader", { staticClass: "space" }, [
                    _vm._v("Aicrafts Log")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.plains,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Select Aircraft"
                    },
                    model: {
                      value: _vm.currentPlain,
                      callback: function($$v) {
                        _vm.currentPlain = $$v
                      },
                      expression: "currentPlain"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("v-select", {
                    attrs: {
                      disabled: this.user.roles.includes("pilot"),
                      items: _vm.pilots,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Select Pilot"
                    },
                    model: {
                      value: _vm.currentPilot,
                      callback: function($$v) {
                        _vm.currentPilot = $$v
                      },
                      expression: "currentPilot"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.checkGate("aircrafts-log-mgmt")
        ? _c(
            "v-data-table",
            {
              attrs: {
                headers: _vm.logHeaders,
                items: _vm.logsByPlain,
                "items-per-page": 50,
                flat: ""
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "item.loadDate",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          "\n      " +
                            _vm._s(
                              new Date(item.loadDate).toLocaleString("en-AU", {
                                timeZone: "UTC",
                                weekday: "short",
                                year: "numeric",
                                month: "short",
                                day: "numeric"
                              })
                            ) +
                            "\n    "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.oil",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.oil
                          ? _c("span", [_vm._v(_vm._s(item.oil) + " qts")])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.fuel",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.fuel
                          ? _c("span", [_vm._v(_vm._s(item.fuel) + " gal")])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.timeXLoad",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.timeXLoad
                          ? _c("span", [
                              _vm._v(_vm._s(item.timeXLoad.toFixed(2)) + " ")
                            ])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "item.tach_hrs",
                    fn: function(ref) {
                      var item = ref.item
                      return [_vm._v(_vm._s(item.tach_hrs.toFixed(2)))]
                    }
                  }
                ],
                null,
                false,
                1045983070
              )
            },
            [
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _vm._v(" "),
              _c("template", { slot: "body.append" }, [
                _c("tr", { staticClass: "pink--text" }, [
                  _c("th", { staticClass: "title" }, [_vm._v("Totals")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.sum(_vm.logsByPlain, "hobbs")))
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.sum(_vm.logsByPlain, "tachtime")))
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.sum(_vm.logsByPlain, "oil")) + " qts")
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.sum(_vm.logsByPlain, "fuel")) + " gal")
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "title" }, [_vm._v("  ")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "title" }, [_vm._v("  ")]),
                  _vm._v(" "),
                  _c("th", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.sum(_vm.logsByPlain, "completeLoads")))
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.sum(_vm.logsByPlain, "tach_hrs")))
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "title" }, [
                    _vm._v(
                      _vm._s(
                        (
                          _vm.sum(_vm.logsByPlain, "tach_hrs") /
                          _vm.sum(_vm.logsByPlain, "completeLoads")
                        ).toFixed(2) || 0
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.avg(_vm.logsByPlain, "fuelXLoad") || 0))
                  ])
                ])
              ])
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.checkGate("packing-jobs-mgmt")
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("v-subheader", [_vm._v("Packing Jobs by Date")]),
                  _vm._v(" "),
                  _c(
                    "v-data-table",
                    {
                      attrs: {
                        headers: _vm.packingJobsHeaders,
                        "no-data-text":
                          "Change the Date Period to see information",
                        items: _vm.packingjobs
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.packDate",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      new Date(item.packDate).toLocaleString(
                                        "en-AU",
                                        {
                                          timeZone: "UTC",
                                          weekday: "short",
                                          year: "numeric",
                                          month: "short",
                                          day: "numeric"
                                        }
                                      )
                                    ) +
                                    "\n\n        "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        613521599
                      )
                    },
                    [
                      _vm._v(" "),
                      _c("template", { slot: "body.append" }, [
                        _c(
                          "tr",
                          { staticClass: "pink--text" },
                          _vm._l(_vm.packingJobsHeaders, function(item, index) {
                            return _c("th", { staticClass: "title" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    index > 0 && index <= 3
                                      ? _vm.sum(_vm.packingjobs, item.value)
                                      : " "
                                  ) +
                                  " "
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("v-select", {
                    attrs: {
                      "max-width": "30%",
                      items: _vm.packers,
                      "item-text": "name",
                      "item-value": "id",
                      label: "Select Packer"
                    },
                    model: {
                      value: _vm.currentPacker,
                      callback: function($$v) {
                        _vm.currentPacker = $$v
                      },
                      expression: "currentPacker"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "v-data-table",
                    {
                      attrs: {
                        headers: _vm.packingJobsbyRigHeaders,
                        "no-data-text": "Select a Packer from the list above",
                        items: _vm.jobsByPacker
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "item.total",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "span",
                                  { staticClass: "pink--text title" },
                                  [_vm._v(_vm._s(item.total))]
                                )
                              ]
                            }
                          },
                          {
                            key: "item.packDate",
                            fn: function(ref) {
                              var item = ref.item
                              return [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      new Date(item.packDate).toLocaleString(
                                        "en-AU",
                                        {
                                          timeZone: "UTC",
                                          weekday: "short",
                                          year: "numeric",
                                          month: "short",
                                          day: "numeric"
                                        }
                                      )
                                    ) +
                                    "\n\n        "
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        765306853
                      )
                    },
                    [
                      _vm._v(" "),
                      _vm._v(" "),
                      _c("template", { slot: "body.append" }, [
                        _c(
                          "tr",
                          { staticClass: "pink--text" },
                          _vm._l(_vm.packingJobsbyRigHeaders, function(
                            item,
                            index
                          ) {
                            return _c("th", { staticClass: "title" }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    index > 1
                                      ? _vm.sum(_vm.jobsByPacker, item.value)
                                      : " "
                                  ) +
                                  "\n            "
                              )
                            ])
                          }),
                          0
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }